module.exports = __webpack_public_path__ + "img/animation.6396a10a.png";